export const footerElement = [
  {
    id: 'about',
    label: 'About Us',
    url: 'https://docs.google.com/document/u/2/d/e/2PACX-1vQkcMPloSDJ8MkrMG_FRMkIjSaZetBijYE_W5jP0JUV7i5F-QWEIT0qWDOjZyA7Bc1Pp-ZalzkVOmRO/pub',
  },
  {
    id: 'affiliateProgram',
    label: 'Affiliate Program',
    url: 'https://docs.google.com/document/d/e/2PACX-1vSRf1LwENePZk-ev9fatwbo0GcFz_3C2SoUe7PIZ7NCl7qaLj65PfAHX81tYq2QS99LdGVwywDqI2l3/pub',
  },
  {
    id: 'events',
    label: 'Events',
    url: '/events',
  },
  {
    id: 'privacy',
    label: 'Privacy Policy',
    url: 'https://docs.google.com/document/d/e/2PACX-1vTqrU0A6EgbHuIQgW6RadN65qJUOevut1lG6tdSkL5Opi3pWmp1ospxbiljvqYyFkNF0f0QDGDwkO3s/pub',
  },
  {
    id: 'cookie',
    label: 'Cookie Policy',
    url: 'https://docs.google.com/document/d/e/2PACX-1vR3JwHEwMvvgXIe0XAWCKN2pv2TgUny59H0Ogh_qitYxlROtPHWGsMIIKvyz5cvWVkhQkPTecGTAJ9b/pub',
  },
  {
    id: 'terms',
    label: 'Terms & Conditions',
    url: 'https://docs.google.com/document/d/e/2PACX-1vSSVhm_vmUzGr2Ly2jMQcW3FCoCppGGa4wBNY2kAIKn9yiFoCWNM_F_-pXc0gsjsskGMHn023Eie-Ad/pub',
  },
  {
    id: 'pricing',
    label: 'Pricing',
    url: 'https://docs.google.com/document/d/e/2PACX-1vTSr9TyX5dAyYL3wRfOHNNuXul1PbJNNrk_KC1kvSTTb2DNjkwCHSXAGg0dxk-evddS8OxiZpE9NX9M/pub',
  },
  {
    id: 'recruitierPricing',
    label: 'Recruiter Pricing',
    url: 'https://docs.google.com/document/d/e/2PACX-1vTXTn9o0OjNV_tffHl3zdc_Z08qVywpfDoQrjEzNkrsGrG_TQdX7rX1rgqwVIxBcXp2jVtNpjE0qAL-/pub',
  },
  {
    id: 'faq',
    label: 'FAQs',
    url: '/faqs',
  },
  {
    id: 'feedback',
    label: 'Contact Us/Feedback',
    url: '#feedback',
  },
  {
    id: 'linkedin',
    label: 'LinkedIn',
    url: 'https://www.linkedin.com/company/alignmycareer-by-jobihood/',
  },
  {
    id: 'facebook',
    label: 'Facebook',
    url: 'https://www.facebook.com/Alignmycareerofficial',
  },
  {
    id: 'twitter',
    label: 'Twitter',
    url: 'https://www.google.com/',
  },
  {
    id: 'instagram',
    label: 'Instagram',
    url: 'https://www.instagram.com/alignmycareerdotcom/',
  },
  {
    id: 'register',
    label: 'Register',
    url: '/register',
  },
  {
    id: 'findJob',
    label: 'Find Job',
    url: '/find-jobs',
  },
  {
    id: 'findTalent',
    label: 'Find Talent',
    url: '/find-candidates',
  },
  {
    id: 'assessments',
    label: 'Assessments',
    url: '/assessments',
  },
  {
    id: 'employerAssessments',
    label: 'Assessments',
    url: '/recuriter/assessments',
  },
  {
    id: 'aiInterviews',
    label: 'AI Interviews',
    url: '/recuriter/aiinterviews',
  },
  {
    id: 'mockInterviews',
    label: 'Mock Interviews',
    url: '/mockinterview',
  },
  {
    id: 'companyReviews',
    label: 'Company Reviews',
    url: '/employer-details',
  },
];

export const footerTitle =
  'A platform to ease the pain out of hiring and job-hunting process.';

export const footerTabsTitle = {
  company: 'Company',
  jobSeeker: 'Job Seeker',
  employer: 'Employer',
  policy: 'Policy',
};

export const footerCopyWriteText = '© 2025 AlignMyCareer. All Rights Reserved';
